import { Directive, ElementRef, Renderer, Input, AfterViewInit } from '@angular/core';

import { Book } from '../../models/Book';

import { BookService } from '../../services/book.service';
import { SharedService } from '../../services/shared.service';

@Directive({
  selector: '[bookRowCatalogo]',
  providers: [BookService],
})
export class BookRowCatalogoDirective implements AfterViewInit {
  @Input() book: Book;

  constructor(
    private service: BookService,
    private sharedService: SharedService,
    private el: ElementRef,
    private renderer: Renderer) {
    this.sharedService.sharedEmitter.subscribe((o) => {
      console.log('Emitted data', o);
      if (o) {
        console.log('BookRowCatalogoDirective (sharedEmitter)', o.ean13);
        if (o.ean13 == this.book.ean13) {
          this.book = o;
          this._render();
        }
      }
    })
  }

  ngAfterViewInit() {
    this._render();
  }

  _render() {
    if (this.book) {
      let wmap = this.service.getCatalogoRow(this.book);
      let html = '<div>';
      html += this.smallCaps(wmap['autori']);
      html += wmap['titolo'] ? '<span class="catalogo-row-titolo">' + wmap['titolo'] + '</span>' : '';
      html += wmap['sottotitolo'] ? '<span class="catalogo-row-sottotitolo">' + wmap['sottotitolo'] + '</span>' : '';
      html += wmap['anno'] ? '<span class="catalogo-row-anno">' + wmap['anno'] + '</span>' : '';
      html += wmap['pagine'] ? '<span class="catalogo-row-pagine">' + wmap['pagine'] + '</span>' : '';
      html += wmap['confezione'] ? '<span class="catalogo-row-confezione">' + wmap['confezione'] + '</span>' : '';
      html += wmap['prezzo'] ? '<span class="catalogo-row-prezzo">' + wmap['prezzo'] + '</span>' : '';
      html += wmap['codice'] ? '<span class="catalogo-row-codice">' + wmap['codice'] + '</span>' : '';
      html += '</div>';
      this.renderer.setElementProperty(this.el.nativeElement, 'innerHTML', html);
    }
  }

  smallCaps(s: string): string {
    let buf = '';
    if (s) {
      s.split('').forEach(c => {
        let upper = (/[A-Z]/.test(c));
        buf += '<span style="font-size: ' + (upper ? '1em' : '0.9em') + ';">' + c.toUpperCase() + '</span>';
      })
    }
    return buf;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/book/book-row-catalogo.directive.ts